import React from "react";
import { Link as GatsbyLink } from "gatsby";
import { IGatsbyImageData } from "gatsby-plugin-image";
import styled from "styled-components";

import { A } from "@util/standard";
import { Image } from "@global";
import { colors } from "@util/constants";
import { Color } from "@util/types";

interface Props {
  linktext?: string | undefined | null;
  url?: string | undefined | null;
  internallink?: boolean | undefined | null;
  newwindow?: boolean | undefined | null;
  asset?: IGatsbyImageData | Record<string, unknown> | undefined | null;
  className?: string;
  color?: Color;
  isUnderlined?: boolean;
  isBold?: boolean;
  hoverColor?: Color;
  padding?: string;
  opacity?: number;
  download?: boolean;
  margin?: string;
  fontWeight?: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  whitespace?: string;
  hoverOpacity?: number;
}

const StyledGatsbyLink = styled(GatsbyLink)<{
  padding?: string;
  underlined?: number;
  opacity?: number;
  margin?: string;
  whitespace?: string;
  hoveropacity?: number;
  color?: Color;
  hoverColor?: Color;
  bold?: boolean;
  fontWeight?: string;
}>`
  ${({ opacity }) => opacity && `opacity: ${opacity};`}
  user-select: none;
  ${({ padding }) => padding && `padding: ${padding}`};
  ${({ margin }) => margin && `margin: ${margin}`};
  ${({ fontWeight }) => fontWeight && `font-weight: ${fontWeight};`}

  ${({ whitespace }) => whitespace && `white-space: ${whitespace}`};

  &:hover {
    text-shadow: 0 0 0.5px ${colors.white};
    ${({ hoveropacity }) => hoveropacity && `opacity: ${hoveropacity}`};
  }

  ${({ bold }) => bold && `font-weight: 600;`}
  ${({ color }) => color && `color:${colors[color]}`};
  ${({ hoverColor }) =>
    hoverColor &&
    `&:hover {
      color: ${colors[hoverColor]};
    }`}
`;

const ImageWrapper = styled.div`
  &:hover {
    opacity: 0.6;
  }
`;

const Link = ({
  linktext,
  url,
  internallink,
  newwindow,
  asset,
  className = "",
  color,
  hoverColor,
  isBold,
  padding,
  opacity,
  download,
  fontWeight,
  margin,
  onClick,
  onMouseEnter,
  whitespace,
  hoverOpacity,
}: Props) => {
  if (internallink) {
    const to = url === "/" ? "/" : `/${url || ""}`;

    return (
      <StyledGatsbyLink
        activeClassName="active"
        className={className}
        to={to}
        padding={padding}
        opacity={opacity}
        margin={margin}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        whitespace={whitespace}
        hoveropacity={hoverOpacity}
        hoverColor={hoverColor}
        color={color}
        bold={isBold}
        fontWeight={fontWeight}
      >
        {asset ? (
          <ImageWrapper>
            <Image imageData={asset} />
          </ImageWrapper>
        ) : (
          linktext
        )}
      </StyledGatsbyLink>
    );
  }

  return (
    <A
      href={url ?? "/"}
      className={className}
      target={newwindow ? "_blank" : ""}
      rel={newwindow ? "noreferrer" : ""}
      color={color}
      hoverColor={hoverColor}
      opacity={opacity}
      onMouseEnter={onMouseEnter}
      download={download}
      fontWeight={fontWeight}
    >
      {asset ? (
        <ImageWrapper>
          <Image imageData={asset} />
        </ImageWrapper>
      ) : (
        linktext
      )}
    </A>
  );
};

export default Link;
